import { compose, withHandlers } from "recompose";

import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";

const notifications = withHandlers({
  sendSuccessCreateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = intl.formatMessage({ id: "ids_projectHasBeenCreated" });
    sendNotification(notif);
  },
  sendFailureCreateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = intl.formatMessage({
      id: "ids_projectSettingsCreateFailed_notification"
    });
    sendNotification(notif);
  }
});

const handlers = withHandlers({
  save: ({
    companyId,
    sendSuccessCreateNotification,
    sendFailureCreateNotification,
    createProject,
    connectProject
  }) => async values => {
    let record = {
      companyId,
      ...values
    };
    try {
      if ( record.name )
        record.name = record.name.trim();
        
      const createRes = await createProject({
        variables: record,
        refetchQueries: [
          {
            query: Queries.getCompanyProjectsForProjectSettings,
            variables: { companyId }
          },
          {
            query: Queries.GET_ALL_PROJECTS,
            variables: { companyId }
          }
        ]
      });
      record["projectId"] = createRes.data.createProject.id;
      record["connectClient"] = !!record.tiersClientId;
      record["connectCollaborator"] = !!record.tiersCollaboratorId;
      record["disconnectClient"] = false;
      record["disconnectCollaborator"] = false;

      await connectProject({
        variables: record
      });

      sendSuccessCreateNotification();
      return createRes;
    } catch (e) {
      console.info("An error occured:", e);
      sendFailureCreateNotification();
    }
  }
});

export default compose(
  injectIntl,
  graphql(Queries.createProject, {
    name: "createProject",
    options: { fetchPolicy: "no-cache" }
  }),
  graphql(Queries.connectProject, {
    name: "connectProject",
    options: { fetchPolicy: "no-cache" }
  }),
  notifications,
  handlers
);
